import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/login-logo.png'
import _imports_1 from '@/assets/img/login-clear.png'


const _withScopeId = n => (_pushScopeId("data-v-883a69fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login-top" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("div", { class: "welcome" }, "欢迎来到 教师资源库"),
    /*#__PURE__*/_createElementVNode("div", { class: "" }, "赶快登录吧！")
  ])
], -1))
const _hoisted_2 = { class: "login-input" }
const _hoisted_3 = { class: "login-account" }
const _hoisted_4 = { class: "login-account" }
const _hoisted_5 = ["src"]

import { onUnmounted, ref } from 'vue'
import Check from './components/check.vue'
import { userLogin, getCenterInfo, getRoleList, getStudioList, getSubjectOption } from '@/api/index'
import AES from '@/utils/AES';
import useHomeStore from '@/store/modules/home'
import useAccountStore from '@/store/modules/account'
import location from "@/utils/location";
import { events } from "@/utils/bus";
import { storeToRefs } from 'pinia';
import { useRouter } from 'vue-router';


import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/message/style/css';
export default {
  __name: 'login',
  setup(__props) {

const domain = location.domain();
const homeStore = useHomeStore()
const accountStore  = useAccountStore()
const { showLogin, isLogin, academicStage, subject, allStage, subjectList, stageAndsubject, showSubjectSelect, current, homepageList, loginFromPersonSpace, defaultTab, memberId, } = storeToRefs(homeStore)

const router = useRouter()
// 用户名
const userName = ref('');
// 密码
const password = ref('');

const showTips = ref(false)

// 验证
const checkFlag = ref(false);
const checkHandle = (val) => {
  checkFlag.value = val;
};

//点击显示密码
const passwordRef = ref()
const passwordPng = ref('password-hidden')
const clickPassword = () => {
  passwordRef.value.type = passwordRef.value.type == 'text' ? 'password' : 'text'
  passwordPng.value = passwordPng.value == 'password-hidden' ? 'password-see' : 'password-hidden'
}

// 登录
const tips = ref('')
const loginHandle = async () => {
  if (!userName.value) {
    tips.value = '请输入账号信息！'
    showTips.value = true
    return;
  }
  if (!password.value) {
    showTips.value = true
    tips.value = '请输入密码！'
    return;
  }
  if (!checkFlag.value.flag) {
    showTips.value = true
    tips.value = '请滑动滑块验证！'
    return;
  }


  const res = await userLogin({
    password: AES.encrypt(password.value),
    username: userName.value,
    verifyImageResult: {
      captchaSerialNumber: checkFlag.value.imgSwipe.captchaSerialNumber,
      moveEnd_X: checkFlag.value.width,
      wbili: 1
    }
  })

  if (res.success) {
    memberId.value = res.data
    //清除掉 登录前选择的学科学段
    if (academicStage.value.id) {
      academicStage.value = {}
      subject.value = {}
    }
    await homeStore.getUserInfo()
    accountStore.accountInfoM()
    password.value = ''
    userName.value = ''
    events.emit('refreshDetail',true)
    router.go(0);
  } else {
    ElMessage.error(res.msg)
  }
}

//去注册
const goRegister = () => {
  window.open(`${domain}/index.html#/register?toUrl=${window.location.href}`)
}

//点击忘记密码
const goForgotPassword = () => {
  window.open(`${domain}/index.html#/forgotPassword?toUrl=${window.location.href}`)
}

//点击遮罩
const loginRef = ref()
const clickBackground = (e) => {
  showLogin.value = false
  // 点击遮罩 此次取消登陆 将loginFromPersonSpace重置为false 否则会有点击上传或其他登陆后会跳转到个人空间问题
  loginFromPersonSpace.value = false
}

const stopClose = (e) => {
  e.stopPropagation()
}

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "login",
    onMousedown: clickBackground
  }, [
    _createElementVNode("div", {
      class: "login-wrap",
      ref_key: "loginRef",
      ref: loginRef,
      onMousedown: _cache[3] || (_cache[3] = $event => (stopClose($event)))
    }, [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: _normalizeClass(["tips", showTips.value ? 'showTips' :''])
        }, _toDisplayString(tips.value), 3),
        _createElementVNode("div", _hoisted_3, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "mb16",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((userName).value = $event)),
            placeholder: "用户名/手机号/身份证号"
          }, null, 512), [
            [
              _vModelText,
              userName.value,
              void 0,
              { trim: true }
            ]
          ]),
          _createElementVNode("img", {
            src: _imports_1,
            onClick: _cache[1] || (_cache[1] = $event => (userName.value='')),
            alt: ""
          })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            type: "password",
            ref_key: "passwordRef",
            ref: passwordRef,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((password).value = $event)),
            placeholder: "登录密码"
          }, null, 512), [
            [
              _vModelText,
              password.value,
              void 0,
              { trim: true }
            ]
          ]),
          _createElementVNode("img", {
            src: require(`@/assets/img/${passwordPng.value}.png`),
            alt: "",
            onClick: clickPassword
          }, null, 8, _hoisted_5)
        ])
      ]),
      _createVNode(Check, {
        style: {"width":"330px"},
        onSuccess: checkHandle
      }),
      _createElementVNode("div", {
        class: "login-btn",
        onClick: loginHandle
      }, "登录"),
      _createElementVNode("div", { class: "login-other" }, [
        _createElementVNode("span", { onClick: goRegister }, "立即注册"),
        _createElementVNode("span", { onClick: goForgotPassword }, "忘记密码")
      ])
    ], 544)
  ], 32))
}
}

}